import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  auth,
  createUserWithEmailAndPassword,
  googleProvider,
  signInWithPopup
} from './firebase/firebase';
import './App.css';

const FIREBASE_ERRORS = {
  'auth/email-already-in-use': 'An account with that email already exists.',
  'auth/invalid-email':        'Please enter a valid email address.',
  'auth/weak-password':        'Password must be at least 6 characters.',
  'auth/popup-closed-by-user': 'Sign-up cancelled.',
  'auth/too-many-requests':    'Too many attempts. Please try again later.',
};

function friendlyError(err) {
  const code = err?.code || '';
  return FIREBASE_ERRORS[code] || 'Something went wrong. Please try again.';
}

function SignUp() {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      navigate('/home');
    } catch (err) {
      setError(friendlyError(err));
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignUp = async () => {
    setError('');
    setLoading(true);
    try {
      await signInWithPopup(auth, googleProvider);
      navigate('/home');
    } catch (err) {
      setError(friendlyError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Create Account</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email" id="email" value={email}
              onChange={(e) => setEmail(e.target.value)}
              required className="form-input" autoComplete="email"
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password <span className="auth-hint">(min. 6 characters)</span></label>
            <input
              type="password" id="password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              required minLength={6} className="form-input" autoComplete="new-password"
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? 'Creating account…' : 'Create Account'}
          </button>
        </form>

        <div className="auth-divider"><span>or</span></div>

        <button onClick={handleGoogleSignUp} className="submit-button google-btn" disabled={loading}>
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" width={18} />
          Sign up with Google
        </button>

        <p className="auth-switch">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
}

export default SignUp;